export default __webpack_public_path__ + "assets/icons/gb.6af0dc33.svg";